import { QueryClient } from '@tanstack/react-query';
// Default staleness for tRPC queries that pull a whole list/table in one go. tRPC builds its own
// QueryClient inside createTRPCNext (it does not use the clients below), and that one runs on React
// Query's defaults: staleTime 0 + refetchOnWindowFocus, so every alt-tab refetched the entire table
// and re-ran the list animation. Mutations invalidate their own list explicitly, which refetches
// regardless of staleness, so this only suppresses the incidental refetches.
export const LIST_QUERY_STALE_TIME_MS = 60 * 1000;
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            // additionally we want to invalidate data on page changes, so
            // add queryClient.invalidateQueries() to link onclick
            refetchOnMount: false,
        },
    },
});
// Quesy client for storing globally available data
export const globalQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            staleTime: 1000 * 60 * 60 * 6, // 6h
        },
    },
});
